export enum ActionButtons {
  ViewAltQuoteButton = "view_altquote_button",
  StartAnApplicationButton = "start_an_application_button",
  RequestReactivationButton = "request_reactivation_button",
}
